import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';

import { AuthService } from './_services/auth.service';
import { AuthInterceptor } from './_services/auth.interceptor';
import { AuthResponseInterceptor } from './_services/auth.response.interceptor';
import { AuthGuard } from './_services/auth.guard';
import { SharedModule } from './shared.module';
import { routes } from './app-routing.module';

import { AppComponent } from './app.component';
import { ForbiddenComponent } from './components/forbidden/forbidden.component';
import { PageNotFoundComponent } from './components/pagenotfound/pagenotfound.component';

@NgModule({
    declarations: [
        AppComponent,
        ForbiddenComponent,
        PageNotFoundComponent
    ],
    imports: [
        HttpClientModule,
        BrowserModule,
        SharedModule.forRoot(),
        routes
    ],
    providers: [
        AuthService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthResponseInterceptor,
            multi: true
        },
        AuthGuard
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }


// WEBPACK FOOTER //
// ./ClientApp/app/app.module.ts